<template>
  <StepLayout
    :keyword="keyword"
    title="症状はいつ頃から始まりましたか？"
    :current-step="2"
    @back="handleBack"
  >
    <OptionList
      v-model="model"
      :options="durationOptions"
      aria-label="症状の期間の選択"
      @select="handleSelect"
    />

    <template #skip>
      <SkipLink label="質問をスキップ" @click="handleSkip" />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import StepLayout from './StepLayoutInline.vue';
import OptionList from './OptionList.vue';
import SkipLink from './SkipLink.vue';
import type { DurationOption } from '../../types';
import { durationOptions } from '../../questions';

defineProps<{
  keyword: string;
}>();

const model = defineModel<DurationOption | null>({ default: null });

const emit = defineEmits<{
  next: [];
  back: [];
  skip: [];
}>();

const handleSelect = () => {
  emit('next');
};

const handleBack = () => {
  emit('back');
};

const handleSkip = () => {
  emit('skip');
};
</script>

<style lang="scss" scoped>
// StepLayout provides all common styling
</style>
